export * from 'webmango-core/titleize'
export { default } from 'webmango-core/titleize'



// WEBPACK FOOTER //
// ./src/utils/titleize.js